import { supabase } from "../supabaseClient";

// Be servern mejla en befintlig användare om en ny roll (api/notify-role.js).
// Returnerar true om mejlet gick iväg. Är utskicket inte uppsatt, eller
// misslyckas det, är rollen ändå tilldelad — då blir svaret bara false.
export async function notifyRoleGranted({ user_id, role, program_id = null, course_id = null }) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return false;
    const res = await fetch("/api/notify-role", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${session.access_token}` },
      body: JSON.stringify({ user_id, role, program_id, course_id }),
    });
    if (!res.ok) return false;
    const json = await res.json().catch(() => null);
    return json?.sent === true;
  } catch {
    return false;
  }
}
